import axios from "axios";

export const JEEP_RALLY_API_BASE_URL = "https://apis-jeeprally.tdcp.gop.pk";

export const getJeepRallyMediaUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

  try {
    const origin = new URL(JEEP_RALLY_API_BASE_URL).origin;
    const normalizedPath = String(pathOrUrl).replace(/\\/g, "/");
    const withSlash = normalizedPath.startsWith("/")
      ? normalizedPath
      : `/${normalizedPath}`;
    return `${origin}${withSlash}`;
  } catch {
    return pathOrUrl;
  }
};

const getJeepRallyAccessToken = () => {
  const userDetails = sessionStorage.getItem("userDetails");
  if (!userDetails) return null;

  try {
    const parsed = JSON.parse(userDetails);
    return parsed?.token || null;
  } catch {
    return null;
  }
};

const jeepRallyApi = axios.create({
  baseURL: JEEP_RALLY_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

jeepRallyApi.interceptors.request.use((config) => {
  const token = getJeepRallyAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }

  return config;
});

jeepRallyApi.interceptors.response.use(
  (response) => response?.data?.data,
  (error) => Promise.reject(error)
);

export { jeepRallyApi };
